import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Stack,
  Title,
  Group,
  SegmentedControl,
  Select,
  Text,
  Grid,
  Box,
} from "@mantine/core";
import { CardMyCollection } from "./Card/CardMyCollection";

const MyCollectionListSection = ({
  isMobile,
  myCollections,
  aggregationType,
  sortMetric,
  handleAggregationTypeChange,
  handleSortMetricChange,
}) => {
  const { t } = useTranslation();
  


  return (
    <Stack gap={24}>
      <Title order={3}>{t("myCollection.myCollection")}</Title>
      <Group position="apart" align="center" wrap="wrap" gap="sm">
        <SegmentedControl
          value={aggregationType}
          onChange={handleAggregationTypeChange}
          size="lg"
          data={[
            { label: "총합", value: "total" },
            { label: "평균", value: "average" },
          ]}
        />
        <Select
          value={sortMetric}
          onChange={handleSortMetricChange}
          data={[
            { label: "조회수", value: "views" },
            { label: "좋아요", value: "likes" },
            { label: "댓글", value: "replies" },
            { label: "리포스트", value: "reposts" },
          ]}
          placeholder="정렬 기준"
          style={{ width: 150 }}
        />
      </Group>
      {myCollections.length === 0 ? (
        <Text c="dimmed" fz="sm" ta="center" py="xl">
          컬렉션이 없습니다. 새 컬렉션을 만들어보세요.
        </Text>
      ) : (
        <Grid gutter="md">
          {myCollections.map((collection, index) => (
            <Grid.Col
              key={`${collection.id || index}-grid`}
              span={isMobile ? 6 : 4}
            >
              <Box h="100%">
                <CardMyCollection
                  collection={collection}
                  isMobile={isMobile}
                  isMe={true}
                  style={{ height: "100%" }}
                />
              </Box>
            </Grid.Col>
          ))}
        </Grid>
      )}
    </Stack>
  );
};

export default MyCollectionListSection;
